<template>
  <div>
    <div class="columns">
      <div class="column">
        <h2 class="title is-3">Список аккаунтов</h2>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <v-text-field
          outlined
          dense
          hide-details
          clearable
          label="Название"
          v-model="params.name"
          @click:clear="onClear"
          @input="getFirebases"
        />
      </div>
      <div class="column">
        <v-select
          outlined
          dense
          hide-details
          clearable
          :items="profiles"
          item-value="id"
          item-text="name"
          label="Пользователь"
          v-model="params.profile_id"
          @input="getFirebases"
        />
      </div>
      <div class="column">
        <v-select
          outlined
          dense
          hide-details
          :items="statuses"
          item-value="value"
          item-text="name"
          label="Статус"
          v-model="params.status"
          @input="getFirebases"
        />
      </div>
      <div class="column">
        <v-select
          outlined
          dense
          hide-details
          :items="platforms"
          item-value="value"
          item-text="name"
          label="Платформа"
          v-model="params.platform"
          @input="getFirebases"
        />
      </div>
      <div class="column">
        <b-button
          class="is-pulled-right"
          type="is-primary"
          icon-right="plus"
          v-if="isAdmin"
          @click="createFirebase"
        >Добавить аккаунт</b-button>
      </div>
    </div>

    <!-- ТАБЛИЦА -->
    <b-table
      :data="firebases.results"
      class="users-table"

      paginated
      backend-pagination
      :total="firebases.total"
      :per-page="params.perPage"
      @page-change="onPageChange"

      detailed
      detail-key="id"
    >
      <b-table-column label="ID" v-slot="props">
        <span>{{ props.row.id }}</span>
      </b-table-column>

      <b-table-column label="Имя" v-slot="props">
        <span>{{ props.row.name }}</span>
      </b-table-column>

      <b-table-column label="Бандл" v-slot="props">
        <span>{{ props.row.bundle }}</span>
      </b-table-column>

      <b-table-column label="Статус" v-slot="props">
        <b-tag :class="getStatusClass(props.row.status)">
          {{ getStatusText(props.row.status) }}
        </b-tag>
      </b-table-column>

      <b-table-column label="Платформа" v-slot="props">
        <span>{{ getPlatformText(props.row.platform) }} {{ getPlatformIcon(props.row.platform) }}</span>
      </b-table-column>

      <b-table-column label="Прокси" v-slot="props">
        <span>{{ (props.row.ip_proxy && props.row.ip_proxy !== '') ? props.row.ip_proxy : 'Нет' }}</span>
      </b-table-column>

      <b-table-column label="Действия" v-slot="props">

        <div>
          <b-tooltip label="Перейти">
            <b-button class="edit_icon" @click="redirectToFirebase(props.row.id)">
              <svg xmlns="http://www.w3.org/2000/svg" style="enable-background:new 0 0 64 64;" viewBox="0 0 64 64" xml:space="preserve">
                    <g>
                      <g transform="translate(382.000000, 380.000000)">
                        <!-- fill="#6d757d" -->
                        <polyline points="-352.3,-343.4 -354.6,-345.7 -328.8,-371.4 -326.6,-369.2 -352.3,-343.4    "/>
                        <polyline points="-326,-354.9 -329.4,-354.9 -329.4,-368.6 -343.1,-368.6 -343.1,-372 -326,-372      -326,-354.9    "/>
                        <path d="M-334.6-324h-34.3c-2.8,0-5.1-2.3-5.1-5.1v-34.3c0-2.8,2.3-5.1,5.1-5.1h18.9v3.4h-18.9     c-0.9,0-1.7,0.8-1.7,1.7v34.3c0,0.9,0.8,1.7,1.7,1.7h34.3c0.9,0,1.7-0.8,1.7-1.7V-348h3.4v18.9C-329.4-326.3-331.7-324-334.6-324     " />
                      </g>
                    </g>
                  </svg>
            </b-button>
          </b-tooltip>

          <b-tooltip label="Редактировать" v-if="isAdmin">
            <b-button class="edit_icon" @click="updateFirebase(props.row.id)">
              <svg viewBox="0 0 24 24" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M4 20h4l10.5 -10.5a1.5 1.5 0 0 0 -4 -4l-10.5 10.5v4"></path>
                <path d="M13.5 6.5l4 4"></path>
              </svg>
            </b-button>
          </b-tooltip>

          <b-tooltip label="Удалить" v-if="isAdmin">
            <b-button
              class="delete_icon"
              @click="deleteFirebase(props.row)">
              <svg viewBox="0 0 24 24" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M4 7l16 0"></path>
                <path d="M10 11l0 6"></path>
                <path d="M14 11l0 6"></path>
                <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"></path>
                <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"></path>
              </svg>
            </b-button>
          </b-tooltip>
        </div>

      </b-table-column>


      <template slot="detail" slot-scope="props">
        <div style="width: 100%; padding: 20px;">
          <!-- Таблица с детальной информацией -->
          <b-table
            :data="[
        { label: 'Прокси', value: props.row.ip_proxy || 'Не указан' },
        { label: 'Домен', value: props.row.domain || 'Не указан' },
        { label: 'CDN', value: props.row.cdn || 'Не указан' },
        { label: 'Формат изображений', value: props.row.size_img || 'Не указан' }
      ]"
            class="detail-table"
          >
            <b-table-column v-slot="data">
              <strong>{{ data.row.label }}</strong>
            </b-table-column>

            <b-table-column v-slot="data">
              <a v-if="data.row.value !== 'Не указан'" @click="copyToClipboard(data.row.value)">{{ data.row.value }}</a>
              <span v-else>{{ data.row.value }}</span>
            </b-table-column>
          </b-table>

          <!-- Информационный блок -->
          <div class="mt-4">

            <div class="info-block">
              <p><strong>API endpoints</strong></p>

              <b-message type="is-warning" size="is-small" class="mt-3">
                <p><strong>Нажми на путь для копирования</strong></p>
              </b-message>

              <div class="endpoint mb-5" @click="copyToClipboard('/api/client/get-all')">
                <div class="endpoint-description">Простое получение данных в формате JSON
                  (<span class="red--text">не используй</span> если планируешь переходить на cdn или уже используешь его):</div>
                <pre class="endpoint-path">/api/client/get-all</pre>
              </div>

              <div class="endpoint mb-5" @click="copyToClipboard('/api/client/export-json/{filename}')">
                <div class="endpoint-description">Экспорт данных в JSON файл (для CDN):</div>
                <pre class="endpoint-path">/api/client/export-json/{filename}</pre>
              </div>

              <div class="example">
                <div class="endpoint-description">Пример:</div>
                <pre class="endpoint-path">/api/client/export-json/data.json</pre>
              </div>
            </div>

            <!-- Предупреждение о данных -->
            <b-message type="is-warning" size="is-small" class="mt-3">
              <div>
                <p><strong>⚠️ Важно:</strong></p>
                <p style="margin-top: 8px;">
                  Если вы не видите в ответе всех коллекций:
                </p>
                <ol style="margin-top: 8px; margin-left: 20px;">
                  <li>Зайдите на мостик</li>
                  <li>Нажмите "Обновить с Firebase"</li>
                  <li>Зайдите в каждую коллекцию на вкладке "Данные" и нажмите "Сохранить и залить"</li>
                </ol>
                <p style="margin-top: 8px;">
                  <strong>Примечание:</strong> Данные обновляются только при заливе с конструктора. С Firebase мостик сам не взаимодействует без "пинка".
                </p>
              </div>
            </b-message>

            <!-- Предупреждение о Swagger -->
            <b-message type="is-danger" size="is-small" class="mt-3">
              <div>
                <p><strong>⚠️ Swagger:</strong></p>
                <p style="margin-top: 8px;">
                  Если кнопка Swagger не привела вас на нужную страницу, вы используете устаревший мостик.
                  <a href="#" @click.prevent="contactSupport">Напишите Кате</a>
                </p>
              </div>
            </b-message>
          </div>

          <!-- Кнопка Swagger -->
          <div class="mt-4">
            <b-tooltip label="Открыть Swagger документацию">
              <b-button
                type="is-primary"
                @click="openSwagger(props.row.ip_proxy)"
                :disabled="!props.row.ip_proxy"
                icon-right="code-tags"
              >
                Swagger API
              </b-button>
            </b-tooltip>
          </div>
        </div>
      </template>

      <!-- Пагинация и выбор количества элементов на странице -->
      <template slot="bottom-left">
        <div class="pagination-controls">
          <v-select
            style="width: fit-content; float: left;"
            v-model="params.perPage"
            @change="getFirebases"
            :items="perPageOptions"
            item-text="name"
            item-value="value"
            outlined
            hide-details
            dense
          />
        </div>
      </template>

    </b-table>

    <OverlayLoader :show="isLoading"></OverlayLoader>
    <FirebaseDetailsModal></FirebaseDetailsModal>
    <FirebaseConfirmDeleteModal></FirebaseConfirmDeleteModal>

  </div>
</template>

<script>
import FirebaseDetailsModal from '@/app/client/firebase/shared/modals/firebaseDetailsModal.vue';
import FirebaseConfirmDeleteModal from '@/app/client/firebase/shared/modals/confirmDeletionFirebaseModal.vue';
import OverlayLoader from "@/app/shared/components/app-loader/Loader";

export default {
  name: "FirebaseList",
  components: {
    OverlayLoader,
    FirebaseDetailsModal,
    FirebaseConfirmDeleteModal
  },
  data() {
    return {
      params: {
        // пагинация
        perPage: 20,
        page: 1,
        name: '',
        profile_id: '',
        status: '',
      },
      maxDetailWidth: 800,
      perPageOptions: [
        { name: "10 на странице", value: 10 },
        { name: "20 на странице", value: 20 },
        { name: "50 на странице", value: 50 },
        { name: "100 на странице", value: 100 },
      ],
      statuses: [
        { value: 'published', name: 'Активные' },
        { value: 'moderation', name: 'Модерация' },
        { value: 'blocked', name: 'Заблокировано' },
        { value: 'in_development', name: 'В разработке' },
        { value: 'deleted', name: 'Удалено' },
        { value: 'another', name: 'Другое' },
        { value: '', name: 'Все' },
      ],
      platforms: [
        { value: 'android', name: 'Android' },
        { value: 'ios', name: 'iOS' },
        { value: 'rustore', name: 'Rustore' },
        { value: '', name: 'Все' },
      ]
    };
  },
  created() {
    this.getFirebases();
    this.$store.dispatch("GET_PROFILES", { type: 'SET_PROFILES' });
  },
  mounted() {
    this.calculateMaxWidth();
    window.addEventListener('resize', this.calculateMaxWidth);
  },
  watch: {
    detailOpened(newVal) {
      if (!newVal) {
        this.getFirebases();
      }
    },
    isOpenConfirmDeletionModalFirebase(newVal) {
      if (!newVal) {
        this.getFirebases();
      }
    }
  },
  computed: {
    isAdmin() {
      return this.$store.getters.IS_ADMIN;
    },
    firebases() {
      return this.$store.getters.GET_FIREBASES;
    },
    detailOpened: {
      get() {
        return this.$store.getters.GET_FIREBASE_DETAILS_MODAL_OPENED;
      },
      set(value) {
        this.$store.commit("SET_FIREBASE_DETAILS_MODAL_OPENED", value);
      },
    },
    isOpenConfirmDeletionModalFirebase: {
      get() {
        return this.$store.getters.GET_FIREBASES_DETAILS_MODAL_CONFIRM_DELETION;
      },
      set(value) {
        this.$store.commit("SET_CONFIRM_DELETION_FIREBASE_MODAL", value);
      }
    },
    isLoading: {
      get() {
        return this.$store.getters.IS_FIREBASES_LOADING;
      },
      set(value) {
        this.$store.commit("SET_FIREBASES_LOADING", value);
      },
    },
    profiles() {
      return this.$store.getters.GET_PROFILES;
    },
  },
  methods: {
    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        this.$toast.success(`Скопировано: ${text}`);
      }).catch(() => {
        this.$toast.error("Не удалось скопировать");
      });
    },
    openSwagger(proxy_url) {
      window.open(proxy_url + '/apidocs', '_blank');
    },
    contactSupport() {
      // Открыть ссылку на Telegram Кати
      window.open('https://t.me/Shiroshe', '_blank');
    },
    calculateMaxWidth() {
      // Получаем ширину родительского контейнера
      const tableElement = this.$el.querySelector('.users-table');
      if (tableElement) {
        this.maxDetailWidth = tableElement.offsetWidth - 12 - 12 - 16 - 16 - 12; // отступы
        // 12 и 12 - это 0.75 rem по бокам
        // 16 - это 1rem по бокам
      }
    },
    onPageChange(page) {
      this.params.page = page;
      this.getFirebases();
    },
    redirectToFirebase(firebase_id) {
      this.$router.push(`/firebases/${firebase_id}/collections`);
    },
    getFirebases() {
      this.$store.dispatch("GET_FIREBASES", this.params).catch(() => {
        this.$toast.error("Ошибка при получении данных");
      });
    },
    updateFirebase(id) {
      this.$store.dispatch("GET_FIREBASE_BY_ID", id).then(() => {
        this.detailOpened = true;
      }).catch(() => {
        this.$toast.error("Ошибка при получении данных");
      });
    },
    deleteFirebase(firebase) {
      this.$store.commit("SET_CURRENT_FIREBASE", firebase);
      this.isOpenConfirmDeletionModalFirebase = true;
    },
    createFirebase() {
      this.$store.commit("SET_CURRENT_FIREBASE", { 'user_access': {'all': true} });
      this.detailOpened = true;
    },
    onClear() {
      this.params.name = '';
      this.getFirebases();
    },
    getStatusText(statusValue) {
      const status = this.statuses.find(s => s.value === statusValue);
      return status ? status.name : statusValue;
    },

    // Получаем название платформы из существующего массива
    getPlatformText(platformValue) {
      const platform = this.platforms.find(p => p.value === platformValue);
      return platform ? platform.name : platformValue;
    },

    // Классы для статусов
    getStatusClass(status) {
      const statusClasses = {
        'published': 'is-success',
        'moderation': 'is-warning',
        'blocked': 'is-danger',
        'in_development': 'is-info',
        'deleted': 'is-dark',
        'another': 'is-light'
      };
      return statusClasses[status] || 'is-light';
    },

    // Иконки для платформ
    getPlatformIcon(platform) {
      const platformIcons = {
        'android': '🤖',
        'ios': '🍎',
        'rustore': '🛒'
      };
      return platformIcons[platform] || 'Не известно';
    }
  },
};
</script>

<style>
.draggable-item {
  border: 1px solid rgba(0, 0, 0, 0.125);
  padding: 10px;
  background-color: #fff;
}
</style>
